import { render, staticRenderFns } from "./SimpleAlert.vue?vue&type=template&id=018402f6&scoped=true&"
import script from "./SimpleAlert.vue?vue&type=script&lang=js&"
export * from "./SimpleAlert.vue?vue&type=script&lang=js&"
import style0 from "./SimpleAlert.vue?vue&type=style&index=0&id=018402f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018402f6",
  null
  
)

export default component.exports